import { render, staticRenderFns } from "./Preservation.vue?vue&type=template&id=cd6c67e2&"
import script from "./Preservation.vue?vue&type=script&lang=ts&"
export * from "./Preservation.vue?vue&type=script&lang=ts&"
import style0 from "./Preservation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports